/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Biosciences17Inputs */

const en__field__enum_studyprograms_study_biosciences17 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Biosciences17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biosciences`)
};

const de__field__enum_studyprograms_study_biosciences17 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Biosciences17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biowissenschaften`)
};

/**
* | output |
* | --- |
* | "Biosciences" |
*
* @param {_Field__Enum_Studyprograms_Study_Biosciences17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_biosciences17 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Biosciences17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Biosciences17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_biosciences17(inputs)
	return de__field__enum_studyprograms_study_biosciences17(inputs)
});
export { _field__enum_studyprograms_study_biosciences17 as "_field__enum_studyPrograms_STUDY_BIOSCIENCES" }